// extracted by mini-css-extract-plugin
export default {"WorkToXLS":"worktoxls_WorkToXLS__v4kC7"};